<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="900" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <!-- Section Settings -->
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <!-- Container Settings -->
        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <!-- Card Title & Image -->
        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Title & Image</label>
            <input type="checkbox" v-model="fields.cardTitle.show" />
          </div>
          <div class="group-item">
            <div class="mb-3">
              <label class="d-block mb-2" style="font-size: 14px; font-weight: 500">Image</label>
              <UploadImage
                @callback="handleUploadImage"
                :image="{ imageSrc: fields.cardImage.src || '' }"
                :height="`200`"
                :typeUpload="'image'"
                @callbackDelete="() => (fields.cardImage.src = '')"
              />
            </div>
            <div>
              <label class="d-block mb-2" style="font-size: 14px; font-weight: 500">Title & Description</label>
              <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
            </div>
          </div>
        </div>

        <!-- Button Settings -->
        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'image-with-text-col-1-section-editor',
  components: {
    UploadImage,
    ButtonPrimary,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Image With Text Col 1 Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardTitle: {
          show: true,
          content:
            '<h1>Lorem ipsum dolor sit amet consectetur adipisicing elit.</h1><p>Minus quis, minima nesciunt voluptatem cupiditate adipisci asperiores debitis vel odit consequatur laboriosam ad officia quisquam enim aliquid delectus sed veritatis perferendis.</p>',
        },
        cardImage: {
          src: '',
        },
        button: {
          show: true,
          backgroundColor: '#ff0000',
          color: '#ffffff',
          radius: 8,
          text: 'Get Started',
          link: '#',
          iconPrefix: { show: false, src: '' },
          iconSuffix: {
            show: true,
            src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
          },
          subBtn: { show: false, text: '' },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardTitle: { ...this.fields.cardTitle, ...(extract.cardTitle || {}) },
        cardImage: { ...this.fields.cardImage, ...(extract.cardImage || {}) },
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionImageWithTextCol1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields.cardImage.src = obj.imageSrc || '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
